<template>
  <div v-if="isOpen" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3 class="modal-title">Unsaved Changes</h3>
        <button @click="$emit('close')" class="modal-close">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="modal-message">
          You have unsaved changes on your profile. Do you want to leave this page without saving?
        </p>
      </div>
      <div class="modal-footer">
        <button @click="$emit('discard')" class="btn-outline-gray">
          Leave Page
        </button>
        <button v-if="!isSaving" @click="$emit('saveAndLeave')" class="btn-outline-primary">
          Save and Leave
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsavedChangesModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'discard', 'saveAndLeave'],
  methods: {
    handleOverlayClick() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
/* Modal styles */
.modal-overlay {
  @apply fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50;
}

.modal-content {
  @apply bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4;
}

.modal-header {
  @apply flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700;
}

.modal-title {
  @apply text-lg font-semibold text-gray-900 dark:text-white;
}

.modal-close {
  @apply text-gray-400 hover:text-gray-600 dark:hover:text-gray-300;
}

.modal-body {
  @apply p-6;
}

.modal-message {
  @apply text-gray-700 dark:text-gray-300;
}

.modal-footer {
  @apply flex justify-between space-x-3 p-6 border-t border-gray-200 dark:border-gray-700;
}

/* Button styles */
.btn-outline-gray {
  @apply px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-transparent border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700;
}

.btn-outline-primary {
  @apply px-4 py-2 text-sm font-medium text-white bg-primary-600 border border-transparent rounded-md hover:bg-primary-700;
}
</style>